import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("新增商城商品")
const _hoisted_6 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = {
  class: "text-muted",
  style: {"font-size":"12px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-muted",
  style: {"font-size":"12px"}
}, "0 = 不限", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-muted",
  style: {"font-size":"12px"}
}, "0 = 不限", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-muted",
  style: {"font-size":"12px"}
}, "0 = 不限(当日)", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("预售")
const _hoisted_13 = {
  key: 0,
  class: "text-muted",
  style: {"font-size":"12px"}
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("现货")
const _hoisted_15 = {
  key: 0,
  class: "text-muted",
  style: {"font-size":"12px"}
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("标记到货")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vxe_input = _resolveComponent("vxe-input")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vxe_form, {
        data: _ctx.formData,
        onSubmit: _ctx.submitEvent
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_form_item, {
            field: "name",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                placeholder: "商品/品牌/IP 名称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "product_brand",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.product_brand,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.product_brand) = $event)),
                placeholder: "品牌",
                filterable: "",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product_brand_options, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.key,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "ip",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.ip,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.ip) = $event)),
                placeholder: "IP",
                filterable: "",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product_ip_options, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.key,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "is_presale",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.is_presale,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.is_presale) = $event)),
                placeholder: "商品类型",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "现货",
                    value: "false"
                  }),
                  _createVNode(_component_el_option, {
                    label: "预售",
                    value: "true"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "is_arrived",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.is_arrived,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.is_arrived) = $event)),
                placeholder: "到货状态",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "已到货",
                    value: "true"
                  }),
                  _createVNode(_component_el_option, {
                    label: "未到货",
                    value: "false"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "in_stock",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.in_stock,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.in_stock) = $event)),
                placeholder: "库存状态",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "有货",
                    value: "true"
                  }),
                  _createVNode(_component_el_option, {
                    label: "缺货",
                    value: "false"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "submit",
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onReset
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_vxe_button, {
                type: "button",
                status: "success",
                onClick: _ctx.onNew
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSubmit"])
    ]),
    _createVNode(_component_vxe_table, {
      ref: "tableRef",
      data: _ctx.tableData,
      "row-config": { isHover: true },
      "sort-config": { remote: true },
      onSortChange: _ctx.onSortChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "id",
          title: "ID",
          width: "80"
        }),
        _createVNode(_component_vxe_column, {
          field: "image_url",
          title: "图片",
          width: "110",
          align: "center"
        }, {
          default: _withCtx(({ row }) => [
            (row.image_url)
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  style: {"width":"70px","height":"70px"},
                  fit: "cover",
                  src: row.image_url,
                  "preview-src-list": [row.image_url]
                }, null, 8, ["src", "preview-src-list"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "无"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "name",
          title: "商品",
          "min-width": "180"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_7, _toDisplayString(row.name), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(row.brand || '-') + " · " + _toDisplayString(row.ip || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "price",
          title: "售价",
          width: "100"
        }),
        _createVNode(_component_vxe_column, {
          field: "mall_stock",
          title: "商城库存",
          width: "150",
          sortable: ""
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_input_number, {
              key: _ctx.inputKeyOf(row, 'mall_stock'),
              modelValue: row.mall_stock,
              "onUpdate:modelValue": ($event: any) => ((row.mall_stock) = $event),
              min: 0,
              precision: 0,
              controls: false,
              "value-on-clear": 0,
              disabled: !!_ctx.savingRows[row.id],
              size: "small",
              style: {"width":"100px"},
              onFocus: ($event: any) => (_ctx.cacheOriginal(row)),
              onChange: ($event: any) => (_ctx.saveField(row, 'mall_stock'))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocus", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "sold_count",
          title: "已售件数",
          width: "110",
          sortable: ""
        }),
        _createVNode(_component_vxe_column, {
          field: "purchase_limit",
          title: "总限购",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_input_number, {
              key: _ctx.inputKeyOf(row, 'purchase_limit'),
              modelValue: row.purchase_limit,
              "onUpdate:modelValue": ($event: any) => ((row.purchase_limit) = $event),
              min: 0,
              precision: 0,
              controls: false,
              "value-on-clear": 0,
              disabled: !!_ctx.savingRows[row.id],
              size: "small",
              style: {"width":"100px"},
              onFocus: ($event: any) => (_ctx.cacheOriginal(row)),
              onChange: ($event: any) => (_ctx.saveField(row, 'purchase_limit'))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocus", "onChange"]),
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "daily_purchase_limit",
          title: "每日限购",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_input_number, {
              key: _ctx.inputKeyOf(row, 'daily_purchase_limit'),
              modelValue: row.daily_purchase_limit,
              "onUpdate:modelValue": ($event: any) => ((row.daily_purchase_limit) = $event),
              min: 0,
              precision: 0,
              controls: false,
              "value-on-clear": 0,
              disabled: !!_ctx.savingRows[row.id],
              size: "small",
              style: {"width":"100px"},
              onFocus: ($event: any) => (_ctx.cacheOriginal(row)),
              onChange: ($event: any) => (_ctx.saveField(row, 'daily_purchase_limit'))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocus", "onChange"]),
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "water_need",
          title: "流水要求",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_input_number, {
              key: _ctx.inputKeyOf(row, 'water_need'),
              modelValue: row.water_need,
              "onUpdate:modelValue": ($event: any) => ((row.water_need) = $event),
              min: 0,
              precision: 0,
              controls: false,
              "value-on-clear": 0,
              disabled: !!_ctx.savingRows[row.id],
              size: "small",
              style: {"width":"100px"},
              onFocus: ($event: any) => (_ctx.cacheOriginal(row)),
              onChange: ($event: any) => (_ctx.saveField(row, 'water_need'))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocus", "onChange"]),
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "is_mall_top",
          title: "置顶",
          width: "90"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_switch, {
              modelValue: row.is_mall_top,
              "onUpdate:modelValue": ($event: any) => ((row.is_mall_top) = $event),
              disabled: !!_ctx.savingRows[row.id],
              onChange: ($event: any) => (_ctx.onToggleTop(row))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "类型",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            (row.is_presale)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_tag, {
                    size: "small",
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_tag, {
                    size: "small",
                    class: "ms-1",
                    type: row.is_arrived ? 'success' : 'info'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.is_arrived ? '已到货' : '未到货'), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"]),
                  (row.arrival_date)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 预计 " + _toDisplayString(row.arrival_date), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  size: "small",
                  type: "success"
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "订金",
          width: "140"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(_ctx.presaleModeText(row.presale_payment_mode)), 1),
            (row.is_presale && row.presale_payment_mode !== 'full_only')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.depositText(row)), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "updated_at",
          title: "更新时间",
          width: "170"
        }),
        _createVNode(_component_vxe_column, {
          field: "updated_by",
          title: "更新人",
          width: "100"
        }),
        _createVNode(_component_vxe_column, {
          title: "操作",
          width: "200",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: ($event: any) => (_ctx.$router.push({ name: 'product_edit', params: { id: row.id } }))
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (row.is_presale && !row.is_arrived)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "warning",
                  size: "small",
                  loading: !!_ctx.savingRows[row.id],
                  onClick: ($event: any) => (_ctx.onMarkArrived(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 2
                }, 1032, ["loading", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "onSortChange"]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"])
  ]))
}